// extracted by mini-css-extract-plugin
export default {"globe":"icons_globe__kwltU","id":"icons_id__NDTba"};